export default "__VITE_ASSET__DvbaaRBM__"